import React from 'react';
export function Footer() {
  return <footer className="py-6 sm:py-10 px-4 border-t border-brand-border bg-brand-paper text-center text-brand-muted text-xs sm:text-sm font-medium" data-id="element-57">
      <div className="max-w-xl mx-auto space-y-3" data-id="element-58">
        <p className="text-brand-forest font-bold uppercase tracking-wider font-serif text-base" data-id="element-59">
          🌿 Hierbas Ancestrales™
        </p>
        <p className="leading-relaxed" data-id="element-60">
          Sabiduría natural para recuperar tu salud y proteger a tu familia.
        </p>
        <p className="text-[10px] sm:text-xs text-brand-muted/70 mt-6" data-id="element-61">
          © Hierbas Ancestrales™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] sm:text-xs text-brand-muted/60 leading-relaxed max-w-md mx-auto" data-id="element-62">
          Aviso legal: La información proporcionada en este material es de
          carácter educativo y no sustituye el consejo médico profesional.
          Consulta a tu médico antes de iniciar cualquier tratamiento natural.
        </p>
      </div>
    </footer>;
}